import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useT } from "@/i18n/I18nContext";

export default function Services() {
  const { t } = useT();
  const items = t("services.items");
  const extraItems = t("services_extra.items");
  return (
    <section id="servicos" data-testid="services-section" className="tt-section relative">
      <div className="mx-auto max-w-[1480px] px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-16">
          <div className="lg:col-span-5">
            <p className="tt-overline">{t("services.overline")}</p>
            <h2 className="mt-4 font-serif text-4xl md:text-6xl leading-[1.02] text-[var(--tt-text)]">
              {t("services.heading_1")} <br />
              {t("services.heading_2")}{" "}
              <em className="italic text-[var(--tt-gold)]">{t("services.heading_3")}</em>.
            </h2>
          </div>
          <p className="lg:col-span-7 text-[var(--tt-text-dim)] font-light leading-relaxed lg:text-lg lg:pt-6">
            {t("services.sub")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[var(--tt-border)] rounded-sm overflow-hidden">
          {items.map((s, i) => {
            const code = String(i + 1).padStart(2, "0");
            return (
              <motion.article
                key={code}
                data-testid={`service-${code}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: i * 0.07 }}
                className="group relative bg-[var(--tt-bg)] p-8 md:p-12 transition-colors duration-500 hover:bg-[var(--tt-surface-2)]"
              >
                <div className="flex items-start justify-between">
                  <span className="tt-overline text-[var(--tt-gold)]">{code}</span>
                  <ArrowUpRight
                    size={22}
                    className="text-[var(--tt-text-muted)] group-hover:text-[var(--tt-text)] transition-all duration-500 group-hover:translate-x-1 group-hover:-translate-y-1"
                  />
                </div>
                <h3 className="mt-10 font-serif text-3xl md:text-4xl text-[var(--tt-text)] leading-tight">
                  {s.name}
                </h3>
                <p className="mt-5 text-[var(--tt-text-dim)] font-light leading-relaxed max-w-md">
                  {s.description}
                </p>
              </motion.article>
            );
          })}
        </div>

        {/* Partnership Opportunities pills */}
        <div className="mt-20">
          <div className="flex items-end justify-between flex-wrap gap-6 mb-8">
            <p className="tt-overline text-[var(--tt-gold)]">{t("services_extra.sub")}</p>
            <a
              href="#contacto"
              data-testid="services-cta"
              className="tt-btn"
            >
              {t("services_extra.cta")}
            </a>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {extraItems.map((item, i) => (
              <motion.div
                key={item}
                data-testid={`partnership-${i}`}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.04 }}
                className="group flex items-center gap-3 rounded-sm border border-[var(--tt-border)] px-5 py-4 transition-all duration-500 hover:border-[var(--tt-gold)] hover:bg-[var(--tt-surface)]"
              >
                <span
                  className="w-1.5 h-1.5 rounded-full transition-transform duration-500 group-hover:scale-150"
                  style={{ background: "var(--tt-gold)" }}
                />
                <span className="font-serif text-base md:text-lg text-[var(--tt-text)]">
                  {item}
                </span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
